var serviceUrl = "//api.reciteme.com/asset/js?key=";
var serviceKey = "874b1a573ba76a618fa4910d4a57231e75abb843";
var options = {}; // Options can be added as needed
var autoLoad = false;
var enableFragment = "#reciteEnable";
var loaded = [], frag = !1; window.location.hash === enableFragment && (frag = !0); function loadScript(c, b) { var a = document.createElement("script"); a.type = "text/javascript"; a.readyState ? a.onreadystatechange = function () { if ("loaded" == a.readyState || "complete" == a.readyState) a.onreadystatechange = null, void 0 != b && b() } : void 0 != b && (a.onload = function () { b() }); a.src = c; document.getElementsByTagName("head")[0].appendChild(a) } function _rc(c) { c += "="; for (var b = document.cookie.split(";"), a = 0; a < b.length; a++) { for (var d = b[a]; " " == d.charAt(0);)d = d.substring(1, d.length); if (0 == d.indexOf(c)) return d.substring(c.length, d.length) } return null } function loadService(c) { for (var b = serviceUrl + serviceKey, a = 0; a < loaded.length; a++)if (loaded[a] == b) return; loaded.push(b); loadScript(serviceUrl + serviceKey, function () { "function" === typeof _reciteLoaded && _reciteLoaded(); "function" == typeof c && c(); Recite.load(options); Recite.Event.subscribe("Recite:load", function () { Recite.enable() }) }) } "true" == _rc("Recite.Persist") && loadService(); if (autoLoad && "false" != _rc("Recite.Persist") || frag) document.addEventListener ? document.addEventListener("DOMContentLoaded", function (c) { loadService() }) : loadService();

// Array of languages.
var arr = {
    en: ["English - GB", "English - GB", "ltr", true],
    pl: ["Polish", "polski", "ltr", true],
    pa: ["Punjabi", "à¨ªà©°à¨œà¨¾à¨¬à©€", "ltr", false],
    ur: ["Urdu", "Ø§Ø±Ø¯Ùˆ", "rtl", true],
    bn: ["Bengali", "à¦¬à¦¾à¦‚à¦²à¦¾ (baÉ›á¹…lÄ)", "ltr", true],
    ar: ["Arabic", "Ø¹Ø±Ø¨ÙŠ", "rtl", true],
    pt: ["Portuguese", "portuguÃªs", "ltr", true],
    ro: ["Romanian", "romÃ¢nÄƒ", "ltr", true],
    "es-ES": ["Spanish - Europe", "espaÃ±ol", "ltr", true],
    "zh-CN": ["Chinese Simplified", "ä¸­å›½ç®€åŒ–", "ltr", true],
    hi: ["Hindi", "à¤¹à¤¿à¤¨à¥à¤¦à¥€", "ltr", true],
    gu: ["Gujarati", "àª—à«àªœàª°àª¾àª¤à«€", "ltr", true],
    tr: ["Turkish", "TÃ¼rkÃ§e", "ltr", true],
    so: ["Somali", "af Soomaali", "ltr", true],
    "fr-FR": ["French - Europe", "franÃ§ais", "ltr", true],
    it: ["Italian", "italiano", "ltr", true],
    af: ["Afrikaans", "Afrikaans", "ltr", true],
    sq: ["Albanian", "shqip", "ltr", false],
    am: ["Amharic", "áŠ£áˆ›áˆ­áŠ›", "ltr", true],
    hy: ["Armenian", "Õ€Õ¡ÕµÕ¥Ö€Õ§Õ¶", "ltr", false],
    as: ["Assamese", "à¦…à¦¸à¦®à§€à§Ÿà¦¾ (asamÄ«yÌ‡a)", "ltr", false],
    ay: ["Aymara", "aymar aru", "ltr", false],
    az: ["Azerbaijani", "Ø¢Ø°Ø±Ø¨Ø§ÙŠØ¬Ø§Ù†Ø¬Ø§ Ø¯ÙŠÙ„ÙŠ", "ltr", false],
    bm: ["Bambara", "Bamanankan", "ltr", false],
    eu: ["Basque", "euskara", "ltr", false],
    be: ["Belarusian", "Ð‘ÐµÐ»Ð°Ñ€ÑƒÑÐºÐ°Ñ Ð¼Ð¾Ð²Ð°", "ltr", false],
    bho: ["Bhojpuri", "à¤­à¥‹à¤œà¤ªà¥à¤°à¥€ (bÊ°ojpurÄ«)", "ltr", false],
    bs: ["Bosnian", "bosanski", "ltr", false],
    bg: ["Bulgarian", "Ð±ÑŠÐ»Ð³Ð°Ñ€ÑÐºÐ¸ (bÃ£lgarski)", "ltr", true],
    ca: ["Catalan", "catalÃ ", "ltr", true],
    ceb: ["Cebuano", "Sinugboanon", "ltr", false],
    ny: ["Chichewa", "ChicheÅµa", "ltr", false],
    "zh-TW": ["Chinese Traditional", "ä¸­åœ‹å‚³çµ±", "ltr", true],
    co: ["Corsican", "corsu", "ltr", false],
    hr: ["Croatian", "Hrvatski", "ltr", true],
    cs: ["Czech", "ÄeÅ¡tina", "ltr", true],
    da: ["Danish", "dansk", "ltr", true],
    dv: ["Dhivehi", "Þ‹Þ¨ÞˆÞ¬Þ€Þ¨ (dhivehi)", "rtl", false],
    doi: ["Dogri", "Dogra à¤¡à¥‹à¤—à¤°à¥€", "ltr", false],
    nl: ["Dutch", "Nederlands", "ltr", true],
    eo: ["Esperanto", "Esperanto", "ltr", false],
    et: ["Estonian", "eesti keel", "ltr", false],
    ee: ["Ewe", "EÊ‹egbe", "ltr", false],
    tl: ["Filipino", "filipino", "ltr", false],
    fi: ["Finnish", "suomi", "ltr", true],
    "fr-CA": ["French - Canadian", "franÃ§ais canadien", "ltr", true],
    fy: ["Frisian (West)", "Frysk", "ltr", false],
    gl: ["Galician", "Galego", "ltr", true],
    ka: ["Georgian", "áƒ¥áƒáƒ áƒ—áƒ£áƒšáƒ˜ (kÊ»artÊ»uli)", "ltr", false],
    de: ["German", "Deutsch", "ltr", true],
    el: ["Greek", "ÎµÎ»Î»Î·Î½Î¹ÎºÎ¬", "ltr", true],
    gn: ["Guarani", "AvaÃ±eâ€™áº½", "ltr", false],
    ht: ["Haitian Creole", "KreyÃ²l ayisyen", "ltr", false],
    ha: ["Hausa", "Ø­ÙŽÙˆÙ’Ø³", "ltr", false],
    haw: ["Hawaiian", "Ê»Ålelo HawaiÊ»i", "ltr", false],
    iw: ["Hebrew", "×¢Ö´×‘Ö°×¨Ö´×™×ª", "rtl", true],
    hmn: ["Hmong", "Hmong", "ltr", false],
    hu: ["Hungarian", "Hungarian Magyar", "ltr", true],
    is: ["Icelandic", "Ãslenska", "ltr", true],
    ig: ["Igbo", "Igbo", "ltr", false],
    ilo: ["Ilocano", "ilokano", "ltr", false],
    id: ["Indonesian", "Bahasa Indonesia", "ltr", true],
    ga: ["Irish (Gaelic)", "Gaeilge", "ltr", true],
    ja: ["Japanese", "æ—¥æœ¬èªž", "ltr", true],
    jv: ["Javanese", "baá¹£a Jawa", "ltr", false],
    kn: ["Kannada", "à²•à²¨à³à²¨à²¡", "ltr", true],
    kk: ["Kazakh", "ÒšÐ°Ð·Ð°Ò› Ñ‚Ñ–Ð»Ñ–", "ltr", false],
    km: ["Khmer", "áž—áž¶ážŸáž¶ážáŸ’áž˜áŸ‚ážš", "ltr", true],
    gom: ["Konkani", "à¤•à¥‹à¤‚à¤•à¤£à¥€ (kÅnÌ‡kanÌ£Ä«) à²•à³Šà²‚à²•à²£à²¿ (konÌ‡kanÌ£i)", "ltr", false],
    ko: ["Korean", "í•œêµ­ì–´", "ltr", true],
    kri: ["Krio", "Krio", "ltr", false],
    ku: ["Kurdish", "Kurmanji", "rtl", false],
    ckb: ["Kurdish (Sorani)", "KurdÃ­ / Ú©ÙˆØ±Ø¯ÛŒ / Ðºâ€™Ã¶Ñ€Ð´Ð¸", "rtl", false],
    ky: ["Kyrgyz", "Ù‚Ù‰Ø±Ø¹Ù‰Ø²", "ltr", false],
    lo: ["Lao", "àºžàº²àºªàº²àº¥àº²àº§", "ltr", true],
    la: ["Latin", "Lingua Latina", "ltr", false],
    lv: ["Latvian", "latvieÅ¡u valoda", "ltr", true],
    ln: ["Lingala", "lingÃ¡la", "ltr", false],
    lt: ["Lithuanian", "lietuviÅ³ kalba", "ltr", true],
    lg: ["Luganda", "Luganda", "ltr", false],
    lb: ["Luxembourgish", "LÃ«tzebuergesch", "ltr", false],
    mk: ["Macedonian", "Ð¼Ð°ÐºÐµÐ´Ð¾Ð½ÑÐºÐ¸", "ltr", true],
    mai: ["Maithili", "à¤®à¥ˆà¤¥à¤¿à¤²à¥€ (mÉ›tÊ°ilÄ«)", "ltr", false],
    mg: ["Malagasy", "Fiteny Malagasy", "ltr", false],
    ms: ["Malay", "Bahasa melayu", "ltr", true],
    ml: ["Malayalam", "à´®à´²à´¯à´¾à´³à´‚", "ltr", true],
    mt: ["Maltese", "Malti", "ltr", true],
    mi: ["Maori", "te Reo MÄori", "ltr", false],
    mr: ["Marathi", "à¤®à¤°à¤¾à¤ à¥€", "ltr", true],
    "mni-mtei": ["Meiteilon (Manipuri)", "Manipuri", "ltr", false],
    lus: ["Mizo", "Mizo á¹­awng", "ltr", false],
    mn: ["Mongolian", "ÐœÐ¾Ð½Ð³Ð¾Ð»", "ltr", false],
    my: ["Myanmar (Burmese)", "á€—á€™á€¬á€…á€€á€¬á€¸", "ltr", false],
    ne: ["Nepali", "à¤¨à¥‡à¤ªà¤¾à¤²à¥€", "ltr", false],
    no: ["Norwegian", "norsk", "ltr", true],
    om: ["Oromo", "Afaan Oromo", "ltr", false],
    ps: ["Pashto", "Ù¾ÚšØªÙˆ", "ltr", false],
    fa: ["Persian (Farsi)", "ÙØ§Ø±Ø³Ù‰", "rtl", true],
    qu: ["Quechua", "Qhichwa", "ltr", false],
    ru: ["Russian", "Ð ÑƒÑÑÐºÐ¸Ð¹ ÑÐ·Ñ‹Ðº", "ltr", true],
    sm: ["Samoan", "Gagana Samoa", "ltr", false],
    sa: ["Sanskrit", "à¤¸à¤‚à¤¸à¥à¤•à¥ƒà¤¤à¤®à¥ (saá¹ƒská¹›tam) à¤¸à¤‚à¤¸à¥à¤•à¥ƒà¤¤à¤¾ à¤­à¤¾à¤·à¤¾ (saá¹ƒská¹›tÄ bhÄá¹£Ä)", "ltr", false],
    gd: ["Scots Gaelic", "GÃ idhlig", "ltr", true],
    nso: ["Sepedi (Pedi)", "Sepedi", "ltr", false],
    sr: ["Serbian", "ÑÑ€Ð¿ÑÐºÐ¸", "ltr", true],
    st: ["Sesotho", "seSotho", "ltr", false],
    sn: ["Shona", "chiShona", "ltr", false],
    sd: ["Sindhi", "Ø³Ù†ÚŒÙŠ", "ltr", false],
    si: ["Sinhala", "à·ƒà·’à¶‚à·„à¶½", "ltr", true],
    sk: ["Slovak", "slovenÄina", "ltr", true],
    sl: ["Slovenian", "slovenÅ¡Äina", "ltr", true],
    "es-US": ["Spanish - US", "espaÃ±ol", "ltr", true],
    su: ["Sundanese", "Basa Sunda", "ltr", true],
    sw: ["Swahili", "Kiswahili", "ltr", false],
    sv: ["Swedish", "svenska", "ltr", true],
    tg: ["Tajik", "Ñ‚Ð¾Ò·Ð¸ÐºÐ¸", "ltr", false],
    ta: ["Tamil", "à®¤à®®à®¿à®´à¯", "ltr", false],
    te: ["Telugu", "à°¤à±†à°²à±à°—à±", "ltr", true],
    th: ["Thai", "à¸ à¸²à¸©à¸²à¹„à¸—à¸¢", "ltr", true],
    ti: ["Tigrinya", "á‰µáŒáˆ­áŠ› (tÉ™gÉ™rÉ™Ã±a)", "ltr", false],
    ts: ["Tsonga", "xiTsonga", "ltr", false],
    ak: ["Twi (Akan)", "twi", "ltr", false],
    uk: ["Ukrainian", "Ð£ÐºÑ€Ð°Ñ—Ð½ÑÑŒÐºÐ°", "ltr", true],
    uz: ["Uzbek", "Ø£Û‡Ø²Ø¨ÛÙƒ ïº—ï»´ï» ÛŒ o'zbek tili ÑžÐ·Ð±ÐµÐº Ñ‚Ð¸Ð»Ð¸", "ltr", true],
    vi: ["Vietnamese", "tiáº¿ng viá»‡t", "ltr", true],
    cy: ["Welsh", "Cymraeg", "ltr", true],
    xh: ["Xhosa", "isiXhosa", "ltr", false],
    yi: ["Yiddish", "×²Ö´×“×™×©", "ltr", false],
    yo: ["Yoruba", "YorÃ¹bÃ¡", "ltr", false],
    zu: ["Zulu", "isiZulu", "ltr", true],
};

// Add language to the dropdown.
var addLanguage = "";
Object.keys(arr).forEach((key) => {
    addLanguage += `
	<ul>
      <li data-recite-translate-skip data-recite-translate="${key}" recite-lang-dir="${arr[key][2]}">
      	<div class='recite_language_main_name_str_dropdown'> ${arr[key][0]}</div>
      	<div class='recite_language_native_name_str_dropdown'>${arr[key][1]} </div>
      	<div class='image_background ${
        arr[key][3] === true ? "recite-sprite-audible-dropdown" : ""
    }'> </div>
      </li>
  </ul>`;
});

var addHTML = `
          <div id="recite-translation-dropdown" style="display: none">
            <div id="recite-scroll-dropdown">
                ${addLanguage}
            </div>
      </div>`;

// Lets add the dropdown on the button
var getLangBtn = document.querySelector("[data-toggle-language]");
if (getLangBtn) {
    if (!typeof reciteLoadandOpenTranslate == "undefined") {
        getLangBtn.removeEventListener("click", reciteLoadandOpenTranslate);
    }
    getLangBtn.insertAdjacentHTML("afterend", addHTML);
}
var translateButtons = document.querySelectorAll("[data-translate], [data-recite-translate]");
for (var i = 0; i < translateButtons.length; i++) {
    translateButtons[i].addEventListener(
        "click",
        function (e) {
            var targetLanguage = this.getAttribute("data-translate");
            let langDir=this.getAttribute("recite-lang-dir");
            if (!targetLanguage) {
                targetLanguage = this.getAttribute("data-recite-translate");
            }
            _handleTranslation(targetLanguage, langDir);
            e.preventDefault();
            e.stopPropagation();
            toggleLanguageMenu();
            return false;
        },
        false
    );
}

// Translation Dropdown:
var translationButton = document.querySelector("[data-toggle-language]");
if (translationButton) {
    translationButton.addEventListener("click", function () {
        toggleLanguageMenu();
    });
}

function toggleLanguageMenu(){
    var translationDropdown = document.querySelector("#recite-translation-dropdown");
    translationDropdown.style.display =
        translationDropdown.style.display == "none" ? "block" : "none";
    if (translationDropdown.style.display == "none") {
        document.querySelectorAll("[data-toggle-language] > svg")[1].classList.remove("openMenu");
    } else {
        document.querySelectorAll("[data-toggle-language] > svg")[1].classList.add("openMenu");
        translationDropdown.classList.remove("recite-dropdown-flipped");
        if (translationDropdown.getBoundingClientRect().left < 10) {
            translationDropdown.classList.add("recite-dropdown-flipped");
        }
    }
}

// Check for and handle stored language:
if (
    _rc("Recite.Persist") === "false" ||
    _rc("Recite.Persist") === null ||
    _rc("Recite.Persist") == "null"
) {
    var storedLang = localStorage.getItem("user_lang");
    if (storedLang != "undefined") {
        _handleTranslation(storedLang);
    }
}

// Handle a translation:
var reciteLoading = false;

function _handleTranslation(lang, langDir) {
    if (lang === null || lang == "null" || lang == _getDocLang()) return;

    if (typeof Recite != "undefined") {
        reciteLoading = false;
        localStorage.setItem("user_lang", lang);
        Recite.Language.Translate.translate(document.getElementsByTagName("body")[0], lang);
        document.querySelector("[data-language-short]").textContent = `${lang.toUpperCase()}`;
        document.querySelector("html").lang = lang;
        document.querySelector("html").dir = langDir;
        if (Recite.isEnabled()) {
            Recite.Preferences.set("language", lang);
        }
    } else {
        //check that we havenâ€™t already requested this -
        if (!reciteLoading) {
            loadAndTranslate(lang);
        }
    }
}

// Load ReciteMe core and schedule an initial translation:
function loadAndTranslate(lang) {
    reciteLoading = true;
    loadScript(serviceUrl + serviceKey, function () {
        _handleTranslation(lang);
        //this is in the script load callback so no â€˜loopingâ€™
    });
}

// Assess the default language of the page:
function _getDocLang() {
    var html = document.getElementsByTagName("html");
    if (html[0].hasAttribute("lang")) {
        return html[0].getAttribute("lang");
    }
    var body = document.getElementsByTagName("body");
    if (body[0].hasAttribute("lang")) {
        return body[0].getAttribute("lang");
    }
    return null;
}
